"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeKbArticleStarterBlocks = serializeKbArticleStarterBlocks;
const kb_article_blocks_1 = require("./kb-article-blocks");
function serializeKbArticleStarterBlocks(input) {
    const blocks = [
        {
            id: 'intro',
            type: 'heading',
            level: 'h2',
            text: input.introHeading,
        },
        {
            id: 'overview',
            type: 'paragraph',
            text: input.overview,
        },
    ];
    if (input.steps) {
        blocks.push({
            id: 'steps',
            type: 'steps',
            title: input.steps.title,
            items: [...input.steps.items],
        });
    }
    if (input.callout) {
        blocks.push({
            id: 'callout',
            type: 'callout',
            tone: input.callout.tone ?? 'info',
            title: input.callout.title,
            text: input.callout.text,
        });
    }
    if (input.cards) {
        blocks.push({
            id: 'cards',
            type: 'cards',
            title: input.cards.title,
            items: input.cards.items.map(item => ({
                title: item.title,
                text: item.text,
                href: item.href ?? null,
            })),
        });
    }
    if (input.cta) {
        blocks.push({
            id: 'cta',
            type: 'cta',
            title: input.cta.title,
            text: input.cta.text,
            label: input.cta.label,
            href: input.cta.href,
        });
    }
    return (0, kb_article_blocks_1.serializeKbArticleBlocks)(blocks);
}
